import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { Answer } from "../../../constants/constants";
import { MappingData } from "../../models/email-to-case";
import { SharedCRMConfigService } from "../../services/shared-crm-config.service";

@Component({
  selector: "shared-email-to-module-record",
  templateUrl: "./email-to-module-record.component.html",
  providers: [ConfirmationService],
})
export class SharedEmailToModuleRecordComponent implements OnInit, OnChanges {

  @Input() channels : any;
  @Input() moduleName : string;
  //#region  properties

  displayAddEditMapping: boolean = false;
  mappingHeader: string = '';
  emailMappingData: MappingData
  mappingForm: FormGroup
  moduleId: number;
  disableChannel: boolean = false;
  allChannelsVm: any;
  answertypeConstants = Answer;

  //#endregion
  


  constructor(
      private confirmationService: ConfirmationService,
      private sharedCRMConfigService: SharedCRMConfigService,
      private fb: FormBuilder,
      private appMainService: AppMainService,
      private messageService: MessageService
  ) { 
  }

  ngOnChanges(changes: SimpleChanges): void { 
    if (this.moduleName == 'case'){
      this.moduleId = 8;
      if (changes.channels && changes.channels.currentValue){
        let channels = changes.channels.currentValue;
        this.allChannelsVm = this.channels = channels.filter(x => x.isActive == true);
      }
    }
    else if (this.moduleName == 'lead'){
      this.moduleId = 1;
      if (changes.channels && changes.channels.currentValue){
        this.allChannelsVm = this.channels;
      }
    }
  }

  ngOnInit(): void {
    this.getEmailMappingData();
  }

  getEmailMappingData(): void {
    this.appMainService.isShowSpinner('getMappingData');
    this.sharedCRMConfigService.getEmailMapping(this.moduleId).subscribe((response) => {
      if(response){
        this.emailMappingData = response || [];
        this.emailMappingData?.channelMappers.forEach( (data) => {
        data.assignedCaseEmail = this.emailMappingData?.email;
        });
      }
      //this.prepareMappingForm();
      this.appMainService.isHideSpinner('getMappingData');
    },(error) => {
      this.appMainService.isHideSpinner('getMappingData');
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message });
    });
  }

  addMapping(): void {
      this.mappingHeader = "Add Mapping";
      this.displayAddEditMapping = true;
      this.disableChannel = false;
      this.prepareMappingForm();
  }

  prepareMappingForm(): void {
    this.mappingForm = this.fb.group({
      id: [0],
      isActive: [false],
      forwardingEmail: ['', [Validators.required, Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)]],
      assignedCaseEmail: [this.emailMappingData?.email],
      channelId: ['', [Validators.required]] 
    });
    this.filterChannel();
  }

  // Required field validation

  get forwardingEmail() {return this.mappingForm.get('forwardingEmail');}
  get channelId() {return this.mappingForm.get('channelId');}

  // Filter channel list according to saved mapping: if any channel have mapping
  // then add form show only unassigned channel in the dropdown
  
  filterChannel() {
    let existingChannels = this.emailMappingData?.channelMappers ? this.emailMappingData.channelMappers.map(x => x.channelId) : [];
    if(existingChannels){
      this.channels = this.channels.filter(x => !existingChannels.includes(x.id));
    }
  }

  editMapping(formData): void {
      this.disableChannel = true;
      this.mappingHeader = "Edit Mapping";
      this.displayAddEditMapping = true;
      this.setEditMappingForm(formData);
  }

  setEditMappingForm(data: any): void{
    this.mappingForm = this.fb.group({
      id: [data?.id],
      isActive: [data?.isActive],
      forwardingEmail: [data?.forwardingEmail, [Validators.required, Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)]],
      assignedCaseEmail: [this.emailMappingData.email],
      channelId: [data?.channelId, [Validators.required]] 
    });
    if (data?.channelId != null) {
      this.channels = this.allChannelsVm;
    }
    this.processSelectedChannel(data?.channelId);
  }

  processSelectedChannel(channelId){
    let selectedChannel = [];
    let patchChannel = {};
    selectedChannel = this.channels != null ? this.channels.filter(x => x.id == channelId) : [];
    patchChannel = Object.assign({}, ...selectedChannel);
    this.mappingForm.patchValue({
      channelId: patchChannel
    });
  }

  saveMapping(): void{
    if (this.mappingForm.valid){
      const mappingData = {
        isActive: this.mappingForm.value['isActive'],
        forwardingEmail: this.mappingForm.value['forwardingEmail'],
        channelId: this.mappingForm.value['channelId']?.id
      };
      //console.log(mappingData);
      this.appMainService.isShowSpinner('saveMapping');
      this.sharedCRMConfigService.addEditEmailMapping(this.moduleId, mappingData).then((response) => {
        this.displayAddEditMapping = false;
        this.mappingForm.reset();
        this.getEmailMappingData();
        this.channels = this.allChannelsVm;
        this.appMainService.isHideSpinner('saveMapping');
        let updateEditText : string = '';
        this.disableChannel ? updateEditText = 'updated' : updateEditText = 'added';
        this.messageService.add({ severity: 'success', summary: 'Success', detail: `Mapping ${updateEditText} successfully...` });
      }).catch((error) => {
        this.displayAddEditMapping = false;
        this.appMainService.isHideSpinner('saveMapping');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message });
      });
    }
    
  }

  deleteMapping(data: any) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this mapping?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('deleteMapping');
        this.sharedCRMConfigService.deleteEmailMapping(this.moduleId, data.channelId).then(
          resp =>{
            this.getEmailMappingData();
            this.channels = this.allChannelsVm;
            this.appMainService.isHideSpinner('deleteMapping');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead to case mapping deleted successfully...' });
          },
          err =>{
            this.appMainService.isHideSpinner('deleteMapping');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message });
          }
        );
      },
      reject: () => {
      }
    });
  }

  cancelMappingForm(): void{
    this.displayAddEditMapping = false;
    this.mappingForm.reset();
  }
}
